import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-back\">\r\n<g clip-path=\"url(#icon-back_clip0_4209_120889)\">\r\n<path d=\"M4.03066 7.78447C4.90215 6.31662 6.50349 5.33333 8.33333 5.33333C11.0947 5.33333 13.3333 7.57193 13.3333 10.3333C13.3333 10.7015 13.6318 11 14 11C14.3682 11 14.6667 10.7015 14.6667 10.3333C14.6667 6.83553 11.8311 4 8.33333 4C6.21243 4 4.33591 5.04225 3.18667 6.64186L2.82869 4.61167C2.76475 4.24907 2.41898 4.00696 2.05639 4.0709C1.69379 4.13483 1.45167 4.48061 1.51561 4.8432L2.21021 8.7824C2.24091 8.95653 2.33952 9.11133 2.48436 9.2128C2.6736 9.34527 2.92517 9.36947 3.13485 9.29633L6.92173 8.6286C7.28433 8.56467 7.52647 8.21893 7.46253 7.85633C7.3986 7.49373 7.0528 7.2516 6.6902 7.31553L4.03066 7.78447Z\" fill=\"#2478E9\" />\r\n</g>\r\n<defs>\r\n<clipPath id=\"icon-back_clip0_4209_120889\">\r\n<rect width=\"16\" height=\"16\" fill=\"white\" />\r\n</clipPath>\r\n</defs>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/back.svg
// module id = vNpC
// module chunks = 3